<template>
  <div>
    <form @submit.prevent="submit">
      <FormItem
        v-model:value="form.password"
        :errors="errors"
        label="新しいパスワード(半角英数字6文字以上)"
        form-id="password"
        form-type="password"
        class="mb-3"
        show-error-message
      />
      <FormItem
        v-model:value="form.passwordConfirmation"
        :errors="errors"
        label="パスワード（確認）"
        form-id="passwordConfirmation"
        form-type="password"
        show-error-message
      />
      <div class="mb-3"></div>
      <div v-if="!loading" class="w-100 d-flex justify-content-center mt-3">
        <OpenSiteBackButton class="me-3" label="戻る" />
        <MoreReadButton
          class="ms-3"
          color="green"
          label="更新"
          button-type="submit"
          :disabled="loading"
          @click="submit"
        />
      </div>

      <i v-else class="pi pi-spin pi-spinner"></i>
    </form>
  </div>
</template>

<script setup lang="ts">
import { useZodScheme } from "/@/vue/composables/zod";
import {
  BasicButton,
  MoreReadButton,
  OpenSiteBackButton,
} from "/@/vue/components/Atom";
import { FormItem } from "/@/vue/components/Molecules";
import {
  PasswordChange,
  PasswordChangeForm,
  PasswordChangeCheckScheme,
} from "/@/types";

interface Props {
  loading?: boolean;
}

interface Emits {
  (e: "submit", form: PasswordChange): void;
}

defineProps<Props>();
const emit = defineEmits<Emits>();

// form

const { useFormAndErrors } = useZodScheme();
const { form, errors, startValidation } = useFormAndErrors<PasswordChangeForm>(
  PasswordChangeCheckScheme
);

function submit() {
  try {
    startValidation.value = true;
    const validForm = PasswordChangeCheckScheme.parse(form);
    emit("submit", validForm);
  } catch (e) {
    console.error("");
  }
}
</script>

<style scoped></style>
